import { render, staticRenderFns } from "./SysHelpIndex2.vue?vue&type=template&id=5417f5de&scoped=true&"
import script from "./SysHelpIndex2.vue?vue&type=script&lang=js&"
export * from "./SysHelpIndex2.vue?vue&type=script&lang=js&"
import style0 from "./SysHelpIndex2.vue?vue&type=style&index=0&id=5417f5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417f5de",
  null
  
)

export default component.exports